import React, { useContext, useEffect, useState } from "react";
import SetupSteps from "./ProjectSetupSteps/SetupSteps";
import SetupKonva from "./SetupKonva/SetupKonva";
import { popupcontext } from "../../../context/Popupscontext";

export default function SetupControl() {
	let { continueSetup, currentPOIId, setContinueSetup, setKonvamode } =
		useContext(popupcontext);
	const numPage = !continueSetup ? 1 : 2;
	const setupId = !continueSetup ? null : currentPOIId;
	const [page, setPage] = useState(numPage);
	const [imageUrl, setImageUrl] = useState(null);
	const [submitAttempt, setSubmitAttempt] = useState(false);
	const [uniqueId, setUniqueId] = useState(setupId);
	const [typeId, setTypeId] = useState(setupId);
	const [select, setSelect] = useState(false);
	const [data, setData] = useState(null);
	const [selected, setSelected] = useState({
		type: null,
		index: null,
		polyid: null,
	}); // { type, index }
	const [fetching, setFetching] = useState(false);
	const [clear, setClear] = useState(false);
	const [back, setBack] = useState(false);
	const [mode, setMode] = useState("none");

	console.log("TYPEID", typeId);
	console.log("UNIQUEID", uniqueId);
	useEffect(() => {
		return () => {
			setPage(1);
			setContinueSetup(false);
			setImageUrl(null);
			setSubmitAttempt(false);
			setUniqueId(null);
			setTypeId(null);
			setSelect(false);
			setData(null);
			setSelected({
				type: null,
				index: null,
				polyid: null,
			});
			setFetching(false);
			setClear(false);
			setKonvamode(false);
		};
	}, []);
	return (
		<>
			<div className="container-fluid">
				<div className="row">
					<div className="col-lg-8">
						{page !== 1 && (
							<SetupKonva
								imageUrl={imageUrl}
								setImageUrl={setImageUrl}
								submitAttempt={submitAttempt}
								setUniqueId={setUniqueId}
								uniqueId={uniqueId}
								setData={setData}
								selected={selected}
								setSelected={setSelected}
								select={select}
								setSelect={setSelect}
								typeId={typeId}
								setTypeId={setTypeId}
								page={page}
								fetching={fetching}
								setClear={setClear}
								mode={mode}
								setMode={setMode}
								back={back}
								setBack={setBack}
							/>
						)}
					</div>

					<div className="col-lg-4">
						<SetupSteps
							page={page}
							setPage={setPage}
							setImageUrl={setImageUrl}
							setSubmitAttempt={setSubmitAttempt}
							submitAttempt={submitAttempt}
							setUniqueId={setUniqueId}
							uniqueId={uniqueId}
							selected={selected}
							imageUrl={imageUrl}
							setSelect={setSelect}
							setSelected={setSelected}
							select={select}
							setTypeId={setTypeId}
							typeId={typeId}
							setFetching={setFetching}
							clear={clear}
							setClear={setClear}
							setMode={setMode}
							back={back}
							setBack={setBack}
						/>
					</div>
				</div>
			</div>
		</>
	);
}
